"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_NAME = exports.PLUGIN_ID = exports.IDE_CONFIGURATION_KEY = void 0;
exports.IDE_CONFIGURATION_KEY = 'ide-configurations';
exports.PLUGIN_ID = 'MISCELLANEOUS';
exports.PLUGIN_NAME = 'MISCELLANEOUS';
//# sourceMappingURL=Constants.js.map